<template>
  <div class="fileUploadPanel">
    <label class="block-item m-0" for="mutaleFiles">Files:</label>
    <div v-if="this.mutaleFiles.length > 0" class="file-list mb-1">
      <div v-for="(file, index) in mutaleFiles" :key="index">
        <b-row class="mt-1 ml-1" align-h="between">
          <div>
            {{ file.fileName }}
            <b-icon
              class="mt-1 pointer"
              icon="arrow-down"
              scale="1"
              variant="success"
              @click="downloadFile(index)"
            ></b-icon>
          </div>
          <b-icon
            class="mt-1 mr-4 pointer"
            icon="trash-fill"
            scale="1"
            variant="danger"
            @click="deleteFile(index)"
          ></b-icon>
        </b-row>
        <hr class="m-0 p-0" />
      </div>
    </div>
    <b-form-file
        :disabled="disabled"
        v-model="selectedFile"
        :state="Boolean(selectedFile)"
        placeholder="Choose files or drop those here..."
        drop-placeholder="Drop file here..."
      ></b-form-file>
      <div>
        <b-row
          class="mt-1 ml-1"
          v-for="(file, index) in selectedFiles"
          :key="index"
        >
          {{ file.name }}
          <b-icon
            class="mt-1 ml-1 pointer"
            icon="x-circle"
            scale="1"
            variant="danger"
            @click="removeFile(index)"
          ></b-icon>
        </b-row>
      </div>
    <b-button v-if="!isUploading"
        :disabled="
          (this.selectedFiles.length == 0 || this.isProcessing
            ? true
            : false) || disabled
        "
        class="mt-1"
        block
        variant="primary"
        @click="uploadFiles"
      >
        Upload</b-button
      >
    <b-button v-if="isUploading"
        :disabled="true"
        class="mt-1"
        block
        variant="primary"
      >
      <b-spinner small type="grow"></b-spinner>
        Uploading...</b-button
      >

    <b-modal
      id="file-deletion-confirmation"
      hide-footer
      title="You are deleting a file"
    >
      <p>This file will be permanently deleted.</p>
      <div class="modal-footer">
        <b-button @click="hideModal('file-deletion-confirmation')">
          Cancel
        </b-button>
        <b-button variant="danger" @click="deleteFileTask"> Delete </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import firebase from "firebase/app";

export default {
  props: {
    files: Array,
    id: String,
    disabled: Boolean,
    callBackFunction: {type: Function},
  },
  data() {
    return {
      selectedFile: null,
      selectedFiles: [],
      isUploading: false,
      isProcessing: false,
      isComplete: false,
      uploadedFiles: [],
      uploadedFileNames: [],
      mutaleFiles: [],
    }
  },
  created() {
    this.mutaleFiles = this.files.slice(0);
  },
  watch: {
    selectedFile(newSelectedFile) {
      if (this.selectedFile != null) {
        this.selectedFiles.push(newSelectedFile);
      }
    },
  },
  methods: {
    uploadFiles() {
      console.log(this.selectedFiles);
      console.log(this.mutaleFiles);
      for (var i = 0; i < this.selectedFiles.length; i++) {
        for (var c = 0; c < this.mutaleFiles.length; c++) {
          if (this.selectedFiles[i].name == this.mutaleFiles[c].fileName) {
            console.log(this.selectedFiles[i].name + this.mutaleFiles[c].fileName);
            alert("Do not upload duplicate file!");
            return;
          }
        }
      }
      console.log("uploading starts");
      this.selectedFile = null;
      this.progress = 0;
      this.isUploading = true;
      this.isProcessing = true;

      if (this.selectedFiles.length > 0) {
        var storageRef = firebase.storage().ref();

        for (
          var fileIndex = 0;
          fileIndex < this.selectedFiles.length;
          fileIndex++
        ) {
          var fileName = this.selectedFiles[fileIndex].name;
          this.uploadedFileNames.push(fileName);
        }

        const directoryPrefix = "inscription_bookings/" + this.id + "/";

        for (
          var uploadedFilesIndex = 0;
          uploadedFilesIndex < this.mutaleFiles.length;
          uploadedFilesIndex++
        ) {
          this.uploadedFiles.push(this.mutaleFiles[uploadedFilesIndex]);
        }

        this.uploadFileTask(storageRef, directoryPrefix, 0);
      }
    },
    uploadFileTask(storageRef, directoryPrefix, uploadedFilesCount) {
      if (uploadedFilesCount == this.selectedFiles.length) {
        this.uploadedFiles.concat(this.mutaleFiles);
        var itemRef = firebase
          .firestore()
          .collection("inscription_bookings")
          .doc(this.id);

        itemRef.set(
          {
            mutaleFiles: this.uploadedFiles,
          },
          { merge: true }
        );
        
        this.mutaleFiles = this.uploadedFiles;
        console.log(this.mutaleFiles);
        this.uploadedFiles = [];
        this.selectedFiles = [];
        this.uploadedFileNames = [];
        this.isComplete = true;
        this.isProcessing = false;
        this.isUploading = false;
        this.callBackFunction(this.mutaleFiles);
        alert("Upload successfully.");
        return;
      }

      const self = this;
      const uploadingFile = this.selectedFiles[uploadedFilesCount];
      const uploadingTask = storageRef
        .child(directoryPrefix + uploadingFile.name)
        .put(uploadingFile, uploadingFile.type);
      //uploadingTasks.push(uploadingTask);
      uploadingTask.then((data) => {
        data.ref.getDownloadURL().then((url) => {
          self.uploadedFiles.push({
            fileName: this.uploadedFileNames[uploadedFilesCount],
            fileURL: url,
          });
          ++uploadedFilesCount;
          self.uploadFileTask(
            storageRef,
            directoryPrefix,
            uploadedFilesCount,
            false
          );
        });
      });
    },
    downloadFile(index) {
      window.open(this.mutaleFiles[index].fileURL);
    },
    deleteFile(index) {
      this.deletedFileIndex = index;
      this.showModal("file-deletion-confirmation");
    },
    deleteFileTask() {
      const index = this.deletedFileIndex;
      var deletedFile = this.mutaleFiles[index];
      this.mutaleFiles.splice(index, 1);

      if (deletedFile.fileURL) {
        var storageRef = firebase.storage().ref();
        var desertRef = storageRef.child(
          "inscription_bookings/" + this.id + "/" + deletedFile.fileName
        );

        // Delete the file
        desertRef
          .delete()
          .then(function() {})
          .catch(function(error) {
            alert(error);
          });
      }
      
      this.callBackFunction(this.mutaleFiles);
      this.hideModal("file-deletion-confirmation");
    },
    hideModal(id) {
      this.$bvModal.hide(id);
    },
    showModal(id) {
      this.$bvModal.show(id);
    },
    removeFile: function(index) {
      this.selectedFiles.splice(index, 1);
      this.selectedFile = null;
    },
  }
}
</script>

<style>
.block-item {
  display: block;
}

</style>